import React from 'react';
import './chip.scss';
var CustomChip = function (props) {
    var icon = props.icon, label = props.label, className = props.className, onClick = props.onClick;
    var onClickChip = function (e) {
        if (onClick) {
            onClick(e);
        }
    };
    return React.createElement("div", { className: "custom-chip-container " + className, onClick: onClickChip },
        icon ? React.createElement("span", { className: "custom-chip-icon" }, icon) : "",
        React.createElement("span", { className: "custom-chip-label" }, label));
};
export default CustomChip;
